import { render } from "./shopIndex.vue?vue&type=template&id=c6fe7e58&scoped=true&ts=true"
import script from "./shopIndex.vue?vue&type=script&lang=ts"
export * from "./shopIndex.vue?vue&type=script&lang=ts"

import "./shopIndex.vue?vue&type=style&index=0&id=c6fe7e58&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6fe7e58"]])

export default __exports__